import React, {Fragment} from "react";
import PurchaseList from "../../../editors/lists/purchaseList";
import ComponentConfig from "../../../form/ComponentConfig";
import Select from "../../../form/Select";
import DateTimeInput from "../../../form/DateTimeInput";
import Modal from "../../../layout/Modal";
import {
    BarcodeFormatter,
    CurrencyFormatter,
    PartnerSelect,
    ProductSelect,
    UnitFormatter
} from "../../../../utils/formatters";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput} from "../../../../utils/other";
import PickList from "../../../form/operationlist/PickList";
import isEqual from "lodash-es/isEqual";

export const ProductList = (topProps) => <ComponentConfig componentName="purchaseitem">{
    (props) => {
        const sortable = true;
        const filterable = true;
        const {componentConfig} = props;
        const {purchaseitems, onItemUpdate} = topProps;
        return <SelectorGrid
            component="SwapPaymentPoolItem"
            className="p-small-table"
            view={[componentConfig.idfield, "name", "pickable_qty", "qty", "unit", "listprice", "saleprice", "totalprice", "sku"]}
            columns={{
                "name": {
                    header: 'Megnevezés',
                    width: 2,
                    sortable,
                    filterable
                },
                "sku": {
                    header: 'ISBN',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Fogy. ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency"
                },
                "saleprice": {
                    header: 'Ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency"
                },
                "qty": {
                    header: 'Db',
                    width: 1,
                    sortable,
                    renderer: (value, row) => UnitFormatter((purchaseitems.find((item) => item.id + "" === "" + row.id) || {}).qty || value, row.unit),
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="qty" label={false} focus value={(purchaseitems.find((item) => item.id + "" === "" + props.rowData.id) || {}).qty || value}
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value, {ignoreEqual: true});}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value, {ignoreEqual: true})}/>,
                }
            }}
            onItemUpdate={onItemUpdate}
            orderBy={{field: componentConfig.idfield, direction: "DESC"}}
            value={!purchaseitems.length ? [] : null}
            filter={purchaseitems.length ? [{field: "id", value: purchaseitems.map((item) => item.id), operator: "in"}] : []}
        />
    }
}</ComponentConfig>;

export default class ChangePurchaseItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            product: null,
            partner: null,
            date: null,
            purchase: null,
            purchaseitems: JSON.parse(JSON.stringify(this.props.selection || []))
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.selection, prevProps.selection)) {
            this.setState({purchaseitems: JSON.parse(JSON.stringify(this.props.selection || []))});
        }
    }

    onItemUpdate = (item) => {
        let purchaseitems = [...this.state.purchaseitems];
        const index = purchaseitems.findIndex((i) => i.id + "" === "" + item.id);
        const qty = Math.min(parseFloat(item.pickable_qty), parseFloat(item.qty || "0"));
        if (index !== -1) {
            purchaseitems[index].qty = qty;
        } else {
            item.qty = qty;
            purchaseitems.push(item);
        }
        purchaseitems = purchaseitems.filter((item) => parseFloat(item.qty) > 0);
        this.setState({purchaseitems});
        return true;
    }

    render() {
        const filter = [];
        if (this.state.product) {
            filter.push({field: "items.base_product_id", value: this.state.product.base_product_id});
        }
        if (this.state.partner) {
            filter.push({field: "customer", value: this.state.partner.partner_id});
        }
        if (this.state.date) {
            filter.push({
                filters: [
                    {field: "orderdate", value: this.state.date, operator: "like", matchmode: "start"},
                    {field: "transaction_date", value: this.state.date, operator: "like", matchmode: "start"},
                    {field: "close_date", value: this.state.date, operator: "like", matchmode: "start"},
                ],
                operator: "OR"
            });
        }

        return (
            <Modal
                header="Csere kiválasztás"
                ref={(el) => this.modal = el}
                size={"large"}
                {...this.props}
                disabled={this.props.disabled || this.props.isLoading}
                buttons={[
                {
                    text: "Mégse",
                    props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                    onClose: true,
                    onClick: async () => {
                        try {
                            this.props.hide();
                        } catch (e) {

                        }
                    }
                },
                {
                    text: "Kiválasztás",
                    props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                    onClick: async () => {
                        try {
                            let purchaseitems = [...this.state.purchaseitems];
                            purchaseitems = purchaseitems.filter((item) => parseFloat(item.qty) > 0);
                            this.props.setSelected && this.props.setSelected(purchaseitems);
                            this.props.hide();
                        } catch (e) {

                        }
                    }
                }
            ]}>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <Select
                                name="product"
                                objectValue={true}
                                component="product"
                                labelKey="displayname"
                                valueKey="id"
                                optionsTemplate={ProductSelect}
                                view={["base_product_id"]}
                                isClearable={true}
                                saveChanges={(field, value) => {
                                    this.setState({product: value});
                                }}
                                storeType="remote"
                                label="Termék"
                                searchFormatter={BarcodeFormatter}
                                placeholder="Vonalkód vagy cím"
                                value={this.state.product}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <Select
                                name="partner"
                                optionsTemplate={PartnerSelect}
                                objectValue={true}
                                component="partner"
                                labelKey="name"
                                valueKey="partner_id"
                                isClearable={true}
                                saveChanges={(field, value) => {
                                    this.setState({partner: value});
                                }}
                                storeType="remote"
                                label="Vevő"
                                value={this.state.partner}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <DateTimeInput
                                name="date"
                                isClearable={true}
                                saveChanges={(field, value) => {
                                    this.setState({date: value});
                                }}
                                label="Dátum"
                                value={this.state.date}
                            />
                        </div>
                    </div>
                </div>
                {(this.state.product && (this.state.partner || this.state.date) &&
                <Fragment>
                    <ComponentConfig componentName="purchase">
                        <PurchaseList
                            gridid={false}
                            ref={(el) => this.list = el}
                            swapList={true}
                            filter={filter}
                            namedFilters={false}
                            searchfield={false}
                            selection={this.state.purchase}
                            loadForm={(data) => {
                                this.setState({purchase: data});
                            }}
                        />
                    </ComponentConfig>
                    {(this.state.purchase && <ComponentConfig componentName="purchaseitem">
                        {(props) =>
                            {
                                const sortable = true;
                                const filterable = true;
                                const {componentConfig} = props;
                                return <PickList
                                    className={"p-small-table"}
                                    source={{
                                        component: "SwapPaymentPoolItem",
                                        className: "p-small-table",
                                        rowClassName: (rowData) => {
                                            return {"info color": !!this.state.purchaseitems.find((item) => rowData.id + "" === "" + item.id)};
                                        },
                                        view: [componentConfig.idfield, "name", "pickable_qty", "qty", "unit", "listprice", "saleprice", "totalprice", "sku"],
                                        aggregations: {
                                            fields: {
                                                "qty": {
                                                    field: "qty", type: "SUM"
                                                },
                                                "totalprice": {
                                                    field: "totalprice", type: "SUM"
                                                },
                                            }
                                        },
                                        columns: {
                                            "name": {
                                                header: 'Megnevezés',
                                                width: 2,
                                                sortable,
                                                filterable
                                            },
                                            "sku": {header: 'ISBN', width: 1, sortable, filterable },
                                            "listprice": {
                                                header: 'Fogy. ár',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: CurrencyFormatter,
                                                className: "currency"
                                            },
                                            "saleprice": {
                                                header: 'Ár',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: CurrencyFormatter,
                                                className: "currency"
                                            },
                                            "pickable_qty": {
                                                header: 'Db',
                                                width: 1,
                                                sortable,
                                                renderer: (value, row) => UnitFormatter(value, row.unit),
                                                className: "unit"
                                            }
                                        },
                                        onSelectionChange: (e) => {
                                            return e.value.filter((item) => Math.min(parseFloat(item.pickable_qty), parseFloat(item.qty || "0")) > 0);
                                        },
                                        orderBy: {field: componentConfig.idfield, direction: "DESC"},
                                        selectionMode: "multiple",
                                        filter: [{field: "purchase_id", value: this.state.purchase.id}]
                                    }}
                                    onSourceItemUpdate={(item) => {
                                        const purchaseitems = [...this.state.purchaseitems];
                                        const index = purchaseitems.findIndex((i) => i.id + "" === "" + item.id);
                                        if (index !== -1) {
                                            purchaseitems[index].qty = item.qty;
                                        } else {
                                            purchaseitems.push(item);
                                        }
                                        this.setState({purchaseitems});
                                        return true;
                                    }}
                                    onTransferItems={(event, items) => {
                                        let newPurchaseItems = [];
                                        switch (event.direction) {
                                            case 'toTarget':
                                                newPurchaseItems = [...this.state.purchaseitems];
                                                items.map((item) => {
                                                    const index = newPurchaseItems.findIndex((i) => i.id + "" === "" + item.id);
                                                    if (index === -1) {
                                                        const newItem = JSON.parse(JSON.stringify(item));
                                                        newItem.qty = Math.min(parseFloat(newItem.pickable_qty), parseFloat(newItem.qty || "0"));
                                                        newPurchaseItems.push(newItem);
                                                    }
                                                });
                                                newPurchaseItems = newPurchaseItems.filter((item) => parseFloat(item.qty) > 0);
                                                break;
                                            case 'toSource':
                                                newPurchaseItems = [...this.state.purchaseitems];
                                                newPurchaseItems = newPurchaseItems.filter((item) => !items.find((i) => item.id + "" === "" + i.id));
                                                break;
                                        }
                                        this.setState({purchaseitems: newPurchaseItems});
                                    }}
                                    onTargetItemUpdate={this.onItemUpdate}
                                    target={{
                                        component: "SwapPaymentPoolItem",
                                        className: "p-small-table",
                                        view: [componentConfig.idfield, "name", "pickable_qty", "qty", "unit", "listprice", "saleprice", "totalprice", "sku"],
                                        columns: {
                                            "name": {
                                                header: 'Megnevezés',
                                                width: 2,
                                                sortable,
                                                filterable
                                            },
                                            "sku": {header: 'ISBN', width: 1, sortable, filterable },
                                            "listprice": {
                                                header: 'Fogy. ár',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: CurrencyFormatter,
                                                className: "currency"
                                            },
                                            "saleprice": {
                                                header: 'Ár',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                renderer: CurrencyFormatter,
                                                className: "currency"
                                            },
                                            "qty": {
                                                header: 'Db',
                                                width: 1,
                                                sortable,
                                                renderer: (value, row) => UnitFormatter((this.state.purchaseitems.find((item) => item.id + "" === "" + row.id) || {}).qty || value, row.unit),
                                                className: "unit",
                                                editor:
                                                    (parent) =>
                                                        (props, value) =>
                                                            <TextInput type="number" name="qty" label={false} focus value={(this.state.purchaseitems.find((item) => item.id + "" === "" + props.rowData.id) || {}).qty || value}
                                                                       onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value, {ignoreEqual: true});}}
                                                                       onBlur={(e, field, value) => parent.onEditorValueChange(props, value, {ignoreEqual: true})}/>,
                                            }
                                        },
                                        orderBy: {field: componentConfig.idfield, direction: "DESC"},
                                        value: !this.state.purchaseitems.length ? [] : null,
                                        selectionMode: "multiple",
                                        filter: this.state.purchaseitems.length ? [{field: "id", value: this.state.purchaseitems.map((item) => item.id), operator: "in"}] : []
                                    }}
                                />;
                            }
                        }
                    </ComponentConfig>) || <ProductList purchaseitems={this.state.purchaseitems} onItemUpdate={this.onItemUpdate} />}
                </Fragment>) || <ProductList purchaseitems={this.state.purchaseitems} onItemUpdate={this.onItemUpdate} />}
            </Modal>
        );
    }
}